const Movement = {
  None: 0,
  Up: 1,
  Down: 2
}

export default Movement
